"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelToSnakeCaseObject = exports.snakeToCamelCaseObject = exports.renameProperty = exports.flattenObject = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

/**
 * Recursively flatten a object
 *
 * @param {any} ob - input object that will be flatten
 * @returns flat object
 */
var flattenObject = function flattenObject(obj) {
  var toReturn = {};
  var flatObject;

  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) {
      continue;
    }

    if ((0, _typeof2["default"])(obj[i]) === 'object') {
      flatObject = flattenObject(obj[i]);

      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) {
          continue;
        }

        toReturn[i + (isNaN(x) ? '.' + x : '')] = flatObject[x];
      }
    } else {
      toReturn[i] = obj[i];
    }
  }

  return toReturn;
};

exports.flattenObject = flattenObject;

var renameProperty = function renameProperty(oldName, newName, obj) {
  // Do nothing if the names are the same
  if (oldName === newName) {
    return obj;
  } // Check for the old property name to avoid a ReferenceError in strict mode.


  if (obj.hasOwnProperty(oldName)) {
    obj[newName] = obj[oldName];
    delete obj[oldName];
  }

  return obj;
};

exports.renameProperty = renameProperty;

var snakeToCamelCaseObject = function snakeToCamelCaseObject(obj) {
  if (!obj) {
    return obj;
  }

  var toReturn = obj.constructor === Array ? [] : {};

  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) {
      continue;
    }

    if ((0, _typeof2["default"])(obj[i]) === 'object') {
      toReturn[(0, _camelCase["default"])(i)] = snakeToCamelCaseObject(obj[i]);
    } else {
      toReturn[(0, _camelCase["default"])(i)] = obj[i];
    }
  }

  return toReturn;
};

exports.snakeToCamelCaseObject = snakeToCamelCaseObject;

var camelToSnakeCaseObject = function camelToSnakeCaseObject(obj) {
  if (!obj) {
    return obj;
  }

  var toReturn = obj.constructor === Array ? [] : {};

  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) {
      continue;
    }

    if ((0, _typeof2["default"])(obj[i]) === 'object') {
      toReturn[(0, _snakeCase["default"])(i)] = camelToSnakeCaseObject(obj[i]);
    } else {
      toReturn[(0, _snakeCase["default"])(i)] = obj[i];
    }
  }

  return toReturn;
};

exports.camelToSnakeCaseObject = camelToSnakeCaseObject;